import { EHistoryIsEmpty } from '../../enum'

// Create a union type of all possible values from the enum
type IHistoryIsEmptyLangKey = `${EHistoryIsEmpty}`

export type IHistoryIsEmptyLang = {
	history_is_empty: Record<IHistoryIsEmptyLangKey, string>
}

const langEntries = Object.entries(EHistoryIsEmpty).map(
	([key, value]) => [value, `history_is_empty.${value}`]
)

const langObj: Record<IHistoryIsEmptyLangKey, string> = Object.fromEntries(langEntries)

export const HISTORY_IS_EMPTY_LANG_KEY: IHistoryIsEmptyLang = {
	history_is_empty: langObj
}
